const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "SALUTATIONS_RETRIEVED":
            return action.salutations;

        default:
            return state;
    }
}
